import React, { useMemo } from 'react'
import _ from 'lodash'
import SelectOrCreate from '../../components/form/SelectOrCreate'
import InputField from '../../components/form/InputField'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import { useForm, useField } from 'react-form'

//onboarding guide related imports
import {OnboardingTeacherContext} from '../../contexts/OnboardingTeacherContextProvider'
import {useOnboardingUtils} from '../../components/OnboardingHomepage/useOnboardingUtils'

function Field(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <InputField {...props} input={getInputProps()} />
}

function SelectField(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <SelectOrCreate {...props} input={getInputProps()} />
}

const SectionFormPopup = props => {
  const { onClose, onSubmit, formValues, courseCollection, isSubmitting, errors, handleSubmitSection } = props

  const { Form, values } = useForm({
    defaultValues: useMemo(()=>formValues,[]),
    onSubmit: (values,instance)=>{
      onSubmit(formatValues(values))
    }
  })

  // Turns react-select-compatible values into values that the
  // API endpoint will understand
  const formatValues = vals => {
    const { course, ...rest } = vals
    if(!course){ return vals }

    if(course.__isNew__) {
      return { courseName: course.value, ...rest }
    } else {
      return { courseId: course.value, ...rest }
    }
  }

  return(
    <div className='popup-content new-course-popup popup dialog simple-popup popup dialog--open'>
      <div onClick={onClose} className='popup-background'></div>
      <div className="dialog__content">
        <div className="container-fluid">
          <div className="dialog__overview">
            <h1>New Class</h1>
            <p>Once you create your class, you can invite or create students.</p>
            <button onClick={onClose} className="popup-close close action top-right" data-dialog-close=""><i className="fa fa-times"></i></button>
            <br/>

            <Form className='short-section-form'>
              <Field
                name='name'
                label='Class Name'
              />
              <SelectField
                label='Course/Subject'
                name='course'
                placeholder='Type to create new or select existing'
                selectProps={{
                  options:        courseCollection,
                  isClearable:    true
                }}
              />
              <Field
                name='description'
                label='Description'
                placeholder='Optional'
              />

              <br/>

              <div>
                <button type='submit' disabled={isSubmitting} className='btn btn-primary'>Save</button>
                <span className='submit-aside'>
                  <img className={`loading-gif ${isSubmitting ? '' : 'hidden'}`} src={loadingGif}/>
                  {!_.isEmpty(errors) && <p className='error'>{errors}</p>}
                </span>
              </div>
              <br/><br/><br/>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionFormPopup;
